import { localStorageWrapper } from '~/src/infrastructure/browser/localStorage';
var LocalStorageProvider = function LocalStorageProvider(_, provide) {
  provide('localStorage', localStorageWrapper);
};
export default LocalStorageProvider;